import { ChangeDetectionStrategy, Component, Directive, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapMarker } from '@angular/google-maps';
import { Observable } from 'rxjs';

@Directive({
  selector: 'custom-map-marker',
  exportAs: 'customMapMarker',
  standalone: true,
})
export class CustomMapMarkerDirective extends MapMarker implements OnInit, OnDestroy {
  @Output() readonly spiderClick: Observable<google.maps.MapMouseEvent> = new EventEmitter<google.maps.MapMouseEvent>();

  override ngOnInit(): void {
    super.ngOnInit();

    // this.marker?.setMap(null);

    this.marker?.setOptions({ optimized: false });
    google.maps.event.addListener(this.marker!, 'spider_click', (e: any) => {
      // 'spider_click', not plain 'click'
      (this.spiderClick as EventEmitter<google.maps.MapMouseEvent>).emit(e);
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    google.maps.event.clearInstanceListeners(this.marker!);
  }
}
